import React             from "react";
import Button            from "@mui/material/Button";
import Dialog            from "@mui/material/Dialog";
import DialogActions     from "@mui/material/DialogActions";
import DialogContent     from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useStyles         from "_styles/molecules/confirmModal";

const Component = ( {
	buttonComponent,
	performAction,
	dialogText,
	handleClickOpen,
	handleClose,
	open
} ) => {
	const classes = useStyles ();

	return (
		<div>
			<div onClick = { handleClickOpen }>
				{buttonComponent}
			</div>

			<Dialog
				aria-describedby = "alert-dialog-description"
				aria-labelledby = "alert-dialog-title"
				classes = { {
					root  : classes.dialogContainer,
					paper : classes.dialogPaper
				} }
				onClose = { handleClose }
				open = { open }
			>
				<DialogContent
					style = { {
						padding: "12px 24px"
					} }
				>
					<DialogContentText
						className = { classes.dialogTextStyles }
						id = "alert-dialog-description"
						style = { {
							margin: "0"

						} }
					>
						{dialogText}
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button color = "primary"
						onClick = { handleClose }
					>
						NO
					</Button>

					<Button autoFocus
						color = "primary"
						onClick = { performAction }
					>
						YES
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default Component;
